var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.isLoading,"persistent":"","fullscreen":"","transition":false}},[_c('div',{staticClass:"auth-loading"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"120"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }